import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from '@wix/yoshi-flow-editor';
import styles from './video-roles.scss';

const translations = {
  mobileCrew: 'mobile-overlay.video-description.crew',
  mobileCast: 'mobile-overlay.video-description.cast',
};

export const VideoRoles = withTranslation()(
  class extends React.Component {
    static propTypes = {
      type: PropTypes.string,
      items: PropTypes.array,
      firstLineOnly: PropTypes.bool,
      dataHook: PropTypes.string,
      className: PropTypes.string,
    };

    htmlId = _.uniqueId('roles-label');

    renderRole({ role, name }, index) {
      return (
        <div className={styles.item} role="listitem" key={index}>
          <div className={styles.role}>{role}</div>
          <div className={styles.name}>{name}</div>
        </div>
      );
    }

    render() {
      const {
        className,
        type,
        items,
        dataHook,
        firstLineOnly = false,
      } = this.props;

      if (_.isEmpty(items)) {
        return null;
      }

      return (
        <section
          className={classnames(styles.wrapper, className)}
          data-hook={dataHook}
          aria-labelledby={this.htmlId}
        >
          <header className={styles.title} id={this.htmlId}>
            {this.props.t(translations[type])}
          </header>
          <div className={styles.items} aria-live="polite" role="list">
            {_.map(
              firstLineOnly ? _.slice(items, 0, 2) : items,
              this.renderRole,
            )}
          </div>
        </section>
      );
    }
  },
);
